module.exports = __webpack_public_path__ + "static/portfolio-rossaniyomjeans-ce285b4938817c3535acbbf5cb3b8878.jpg";